import React, { useState } from "react";
import styles from "./Style.module.css";
import { Tabs, Tab, Typography, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { WaitingComponent } from "../../components/index.component";
import NewEditor from "../../components/NewEditor/NewEditor.component";
import useAppSettingHook from "./AppSetting.hook";
import PageBox from "../../components/PageBox/PageBox.component";
import { PrimaryButton } from "../../components/Buttons/PrimaryButton";
import ShadowBox from "../../components/ShadowBox/ShadowBox";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    padding: "20px 0",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: "150px",
  },
  tab: {
    width: "100%",
    alignItems: "baseline",
    paddingLeft: "0",
    "&.Mui-selected": {
      fontWeight: "bold",
      color: theme.palette.text.primary,
    },
  },
}));

const AppSettings = (props) => {
  const {
    value,
    handleTabs,
    handleSubmit,
    form,
    isSubmitting,
    contentRef,
    errorData,
    changeTextData,
  } = useAppSettingHook({});

  const { appSetting, actionUpdatePolicies } = props;

  const a11yProps = (index) => {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  };

  const renderPanel = (value) => {
    return (
      <>
        <Typography
          variant={"h5"}
          color={"text.primary"}
          className={styles.title}
        >
          {value === 0 ? "Privacy Detail" : "Terms Detail"}
        </Typography>

        {value === 0 ? (
          <NewEditor
            title={"PRIVACY"}
            error={errorData?.PRIVACY}
            value={value}
            height={625}
            editorData={form?.PRIVACY}
            handleChangeEditor={(html) => {
              contentRef.current(html, "PRIVACY");
            }}

          />
        ) : (
          <NewEditor
            title={"TERMS"}
            error={errorData?.TERMS}
            value={value}
            height={625}
            editorData={form?.TERMS}
            handleChangeEditor={(html) => {
              contentRef.current(html, "TERMS");
            }}

          />
        )}
      </>
    );
  };

  const classes = useStyles();

  // if (appSetting.is_calling) {
  //     return <WaitingComponent />;
  // }

  return (
    <>
      <ShadowBox width="100%">
        <div className={styles.mainContainer}>
          <Typography
            variant={"title"}
            color={"text.primary"}
            className={styles.title}
          >
            App Settings
          </Typography>

          <div className={classes.root}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleTabs}
              aria-label="Vertical tabs example"
              className={classes.tabs}
            >
              <Tab
                className={classes.tab}
                label="Privacy Policy"
                {...a11yProps(0)}
              />
              <Tab
                className={classes.tab}
                label="Terms & Conditions"
                {...a11yProps(1)}
              />
            </Tabs>
            <div className={styles.tabPanel}>{renderPanel(value)}</div>
          </div>
        </div>
        <div className={styles.saveButton}>
          <PrimaryButton onClick={handleSubmit} sx={{ mt: 2 }} >
            {isSubmitting ? (
              <CircularProgress size={24} color={"primary"} />
            ) : (
              "SAVE"
            )}
          </PrimaryButton>
        </div>
      </ShadowBox>
    </>
  );
};

export default AppSettings;
